export default __webpack_public_path__ + "static/media/asz.0d034581.jpg";